import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Main from '../layout/main.vue'
import Register from '../views/Register.vue'
import OrderDea from '../views/OrderDea.vue'
import api from '../utils/api'
import VehicleDetail from '../views/VehicleDetail.vue'
import OrderTimeUsage from '../views/OrderTimeUsage.vue'
import DriverDetail from '../views/DriverDetail.vue'
import OrderAudit from '../views/OrderAudit.vue'

Vue.use(VueRouter)
let dynamicRoutesLoaded=false 

// 静态路由（不需要权限的路由）
const staticRoutes = [
  {
    path: '/',
    redirect: '/login',
	hidden:true
  },


  {
    path: '/login',
    name: 'Login',
    component: Login,
	hidden:true
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
	hidden:true
  },
 
  {
    path: '/home',
    name: 'Home',
    component: Main,
    children: [
      {
        path: '/home/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { breadcrumb: '首页', menu: '首页', icon: 'el-icon-s-home' }
      },
	  {
	    path: '/order/dea',
	    name: '订单详情',
	    component: OrderDea,
	  	hidden:true
	  },
	  {
	    path: '/order/Audit',
	    name: '订单审核详情',
	    component: OrderAudit,
	  	hidden:true
	  },    
    {
	    path: '/order/time-usage',
	    name: 'OrderTimeUsage',
	    component: OrderTimeUsage,
	  	hidden:true
	  },
      {
	    path: '/vehicle/detail',
	    name: 'VehicleDetail',
	    component: VehicleDetail,
	  	hidden:true
	  },
      {
	    path: '/driver/detail',
	    name: 'DriverDetail',
	    component: DriverDetail,
	  	hidden:true
	  },
      {
	    path: '/order-plan/dispatch-preview',
	    name: 'OrderPlanDispatchPreview',
	    component: () => import('../views/OrderPlanDispatchPreview.vue'),
	  	hidden:true
	  },
    ]
  }
]

const router = new VueRouter({
  routes: staticRoutes
})

function notifyMenusUpdated() {
  window.dispatchEvent(new CustomEvent('menus-updated'))
}

function resetDynamicRoutes() {
  dynamicRoutesLoaded = false
  localStorage.removeItem('menus')
  notifyMenusUpdated()
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else {
    if (token) {
      // 检查是否已经加载了动态路由
     // const dynamicRoutesLoaded = localStorage.getItem('dynamicRoutesLoaded')
      if (!dynamicRoutesLoaded) {
        // 加载动态路由
        loadDynamicRoutes(next, to)
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

// 加载动态路由
function loadDynamicRoutes(next, to) {
  //api.get('/api/Menus')
  api.get('/api/Menus/GetUserMenus')
    .then(response => {
      const menus = response.data || []
      // 转换菜单为路由
      const routes = convertMenusToRoutes(menus)
      // 清空现有的动态路由标志
      //localStorage.removeItem('dynamicRoutesLoaded')
	  dynamicRoutesLoaded=false
      
      // 直接将动态路由添加到顶级
      try {
        // 先清除可能存在的重复路由
        const existingRoutes = router.getRoutes()
        
        // ✅ Vue Router 4 写法 - 遍历添加
        routes.forEach(route => {
          router.addRoute(route)
        })
        
        localStorage.setItem('menus', JSON.stringify(routes))
        notifyMenusUpdated()
        // 存储动态路由已加载的标志
		dynamicRoutesLoaded=true
        //localStorage.setItem('dynamicRoutesLoaded', 'true')
        // 继续导航
        next({ ...to, replace: true })
      } catch (error) {
        console.error('添加路由失败:', error)
        next()
      }
    })
    .catch(error => {
      console.error('加载菜单失败:', error)
    })
}

// 将菜单转换为路由
function convertMenusToRoutes(menus) {
  const routes = []
  menus.forEach(menu => {
    if (!menu.path) {
      return
    }

    const nameArr = menu.path.split('/')
    // 生成唯一的路由名称，使用完整路径的最后两部分
    const uniqueName = nameArr.length > 2 ? `${nameArr[nameArr.length - 2]}_${nameArr[nameArr.length - 1]}` : nameArr[nameArr.length - 1]
    const componentPath = menu.description ? menu.description.replace(/^\//, '') : ''
    const isTopLevel = !menu.parentId
    const hasChildren = menu.children && menu.children.length > 0
    
    
    let route = null

    if (isTopLevel) {
      // 顶级菜单
      if (hasChildren) {
        // 有子菜单的顶级菜单 - 使用Main组件作为容器
        route = {
          path: menu.path.startsWith('/') ? menu.path : `/${menu.path}`,
          name: uniqueName,
          component: Main,
          meta: {
            breadcrumb: menu.name,
            menu: menu.name,
            icon: menu.icon
          }
        }
      } else {
        // 没有子菜单的顶级菜单 - 使用 Main 公共组件作为容器
        route = {
          path: menu.path.startsWith('/') ? menu.path : `/${menu.path}`,
          name: uniqueName,
          component: Main,
          meta: {
            breadcrumb: menu.name,
            menu: menu.name,
            icon: menu.icon
          },
          children: [{
            path: '',
            name: `${uniqueName}_index`,
            component: () => import(`@/${componentPath}.vue`),
            meta: {
              breadcrumb: menu.name,
              menu: menu.name,
              icon: menu.icon
            }
          }]
        }
      }
    } else {
      // 非顶级菜单（子菜单）
      route = {
        path: menu.path.startsWith('/') ? menu.path : `/${menu.path}`,
        name: uniqueName,
        component: () => import(`@/${componentPath}.vue`),
        meta: {
          breadcrumb: menu.name,
          menu: menu.name,
          icon: menu.icon
        }
      }
    }

    // 递归处理子菜单
    if (hasChildren) {
      route.children = convertMenusToRoutes(menu.children)
    }
    
    if (route) {
      routes.push(route)
    }

  })
  return routes
}

router.resetDynamicRoutes = resetDynamicRoutes

export default router
